// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yx4k","select":"styles_select__3CUzz"};